import { loggerFor } from '@app/utils/logger';

export function FeatureTargetValidator(possibleValues: string[], required?: boolean) {
  const logger = loggerFor('FeatureTargetValidator');

  return function (value: string): boolean {
    let isValid: boolean = true;

    let empty: boolean = value == null || value === '';
    const noPossibleValue: boolean = possibleValues.indexOf(value) === -1;
    const invalidPhoneNumber: boolean = !/^\+?\d+(DDI|ddi)?$/.test(value);

    if (required === true) {
      isValid = !empty && (!noPossibleValue || !invalidPhoneNumber);
    } else {
      isValid = empty || !noPossibleValue || !invalidPhoneNumber;
    }

    logger.debug(`Feature target is ${isValid ? 'valid' : 'invalid'}`);

    return isValid;
  };
}
